import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import {
  Action,
  Figure,
  Frame,
  ScrollAnimation,
  ScrollAnimationParent,
  ScrollAnimationChild,
  DataComputed,
  DataModel,
} from '@studiometa/ui';
import { isDev } from './config.js';
import {
  bindClickTracking,
  bindFilterTracking,
  bindFormStartTracking,
  bindLoginPanelTracking,
} from './utils/datalayer.js';
import LookingFor from './components/LookingFor.js';
import GForm from './components/GForm.js';
import { Panel } from '@studiometa/ui';
import Wishlist from './components/Wishlist.js';
import WishlistPopin from './components/WishlistPopin.js';
import Tabs from './components/Tabs.js';
import Menu from './components/Menu.js';
import Filters from './components/Filters.js';
import Search from './components/Search.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Video: Array<Promise<import('./components/Video.js').default>>
 *     Accordion: Array<Promise<import('./components/Accordion.js').default>>
 *     Slider: Array<Promise<import('./components/Slider.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    log: isDev(),
    components: {
      Action,
      Figure,
      Frame,
      Panel,
      Tabs,
      Wishlist,
      WishlistPopin,
      DataComputed,
      DataModel,
      Slider: () => importWhenVisible(() => import('./components/Slider.js'), 'Slider'),
      Video: () => importWhenVisible(() => import('./components/Video.js'), 'Video'),
      Accordion: () => importWhenVisible(() => import('./components/Accordion.js'), 'Accordion'),
      LookingFor,
      GForm,
      ScrollAnimation,
      ScrollAnimationParent,
      ScrollAnimationChild,
      Menu,
      Filters,
      Search,
    },
  };

  /**
   * When items is added to wishlist
   * @param {object} props Props
   * @param {object} props.args arguments
   * @returns {void}
   */
  onWishlistEvent({ args }) {
    this.$children.WishlistPopin[0].open(args[0]);
  }

  /**
   *
   */
  mounted() {
    bindClickTracking();
    bindFilterTracking();
    bindFormStartTracking();
    bindLoginPanelTracking();
  }
}

export default createApp(App);
